import { createAction } from '@reduxjs/toolkit';
import type { AiChatConversationMessageResponse } from '@payer-admin-ui/api/src/ai/responses/AiChatConversationResponse';

export const appendStreamingServerMessage = createAction<{
  conversationId: string;
  requestId: string;
  messageIndex: number;
  message: AiChatConversationMessageResponse;
}>('ai/chat/appendStreamingServerMessage');
